import { HiverAxios, showMessage, sendTrackingEvent } from 'h-commons';
import {
    SAVE_CONNECTOR_TYPE_DONE,
    SAVE_CONNECTOR_TYPE_FAILED,
    SAVE_CONNECTOR_TYPE_INIT,
    typePrefixMap,
    getConnectorEnabled
} from './index';

/**
 * redux async action to save connector config data
 * @param  {string} type         Connector Type
 * @param  {string|number} smid  Shared Mailbox Id  
 */
export const saveConnectorType = (connectorType, data) => dispatch => {
    if (!(connectorType in typePrefixMap)) {
        dispatch({
            type: SAVE_CONNECTOR_TYPE_FAILED,
            error: 'Unsupported Connector'
        });
        return;
    }
    dispatch({
        type: SAVE_CONNECTOR_TYPE_INIT
    });
    const prefix = typePrefixMap[connectorType];
    return HiverAxios({
        url: `${prefix}/save_type`,
        type: 'POST',
        params: data,
        callback: resp => {
            dispatch({
                type: SAVE_CONNECTOR_TYPE_DONE
            });
            dispatch(getConnectorEnabled(connectorType, data.smid));
            showMessage({
                message:'Connector settings updated.',
                type:'success'
            });
            sendTrackingEvent('enabledSMConnector', {connectorName: connectorType});
        },
        onfail: err => {
            dispatch({
                type: SAVE_CONNECTOR_TYPE_FAILED,
                error: err
            });
            showMessage({
                message:'Connector settings update failed.',
                type:'error'
            });
        }
    })
        
}